import GeneralTP from './general';
import MultiplePayersTP from './multiplePayers';
import RealEstatTP from './realestat';

export default {
  GeneralTP,
  MultiplePayersTP,
  RealEstatTP,
};
